import React from 'react';

/**
 * Should not be used directly
 *
 * @see QaNamespace
 * @see useQaNamespace
 */
export const QualityAssuranceNamespaceContext = React.createContext<string | undefined>(undefined);
